export default {
  unknown: 'Unknown',
  unknownUser: 'Unknown user',
  unknownPatient: 'Unknown Patient',
  attachmentsToSend: 'Attachments to send with message',

  resendCodeIn: 'RESEND code in {time} seconds',
  resendCode: 'Resend code',
  mistyped: 'You may have mistyped the URL or the page may have been moved.',
  footerText: '© {year} QliqSOFT, Inc. All rights reserved.',

  dragAndDrop: {
    attachLimit: 'Please attach files with a size less than {size}MB',
  },

  fileSize: ' • {size}',

  subscribedFeatures: {
    features: 'Features',
    newFeaturesSubscribed: 'New Features Subscribed',
    featuresUnsubscribed: 'Features Unsubscribed',
    quincyCheck: 'Quincy',
    qliqChatCheck: 'QliqCHAT',
    othersCheck: 'Others',
    removeWarning:
      'Are you sure you want to disable {featureName} for this group?',
    isQuickFormsSubscribed: 'Quick Forms',
    isFaqsSubscribed: 'FAQs',
    isCareCampaignsSubscribed: 'Care Campaigns',
    isAutoCampaignsSubscribed: 'Automated Care Campaigns',
    isCareCampaignAppointmentsSubscribed: 'Appointments',
    isVirtualVisitsSubscribed: 'Video Visits',
    isVoiceCallsForVirtualConversationsEnabled: 'Audio calls for QuincyCHAT',
    isQuickSignSubscribed: 'Quick Sign',
    isChatBotsSubscribed: 'Chat Bots',
    isQuincyPayEnabled: 'Quincy Pay',
    isChatWidgetsSubscribed: 'Chat Widgets',
    isChatWidgetDomainRedirectEnabled: 'Chat Widget Domain Redirect',
    isSmsLogoSubscribed: 'MMS Logos',
    isEmrSyncIntegrationEnabled: 'EMR Sync Feature',
    isPatientMatchSubscribed: 'Patient Match Feature',
    isPatientValidationIntegrationEnabled: 'Patient Validation Feature',
    isSchedulerIntegrationEnabled: 'Scheduler Feature',
    isSymptomCheckerIntegrationEnabled: 'Symptom Checker Feature',
    isPharmacyIntegrationEnabled: 'Pharmacy Feature',
    isMarketplaceSubscribed: 'Publish to Marketplace Feature',
    isGptStoreSubscribed: 'AI Agent',
    isFillAndSignSubscribed: 'Snap and Sign (Fill and Sign)',
    isGeotimeTrackerSubscribed: 'Visit Path',
    isQliqAssistedCallSubscribed: 'Qliq Assisted Calls',
    isNonQliqMessagesSubscribed: 'Non-Qliq Messages',
    isVideoCallsSubscribed: 'Video Calls',
    isBarcodeScanningSubscribed: 'Barcode Scanning',
    isRolesSubscribed: 'Roles',
    isMessagingPartner: 'Messaging Partner',
    isEscalationSubscribed: 'Escalation',
    isFaxIntegrationSubscribed: 'Fax Integration',
    isOncallCalSubscribed: 'OnCall Schedules',
    isOncallAutomaticRoutingSubscribed: 'OnCall Call Automatic Routing',
    promptWindowsAppUpdate: 'Prompting Windows App Update',
    isIncidentsSubscribed: 'QliqCHAT Issues',
    isNonmemberAdminSubscribed: 'Non-Member Admin',
    isUserManagementApiSubscribed: 'User Management API',
    isSneakPeekSubscribed: 'Sneak Peek',
    isAllowCustomization: 'Branding & Customization',
    isSamlSsoAuthEnabled: 'SAML/SSO Authentication',
    isPlusFormSubscribed: 'Plus Form',
    isScoredFormsSubscribed: 'Scored Forms',
    isStepByStepFormsSubscribed: 'Step-by-Step Forms',
    isPlusSignSubscribed: 'Plus Sign',
    isQliqStorSubscribed: 'QliqSTOR',
    isQliqDirectSubscribed: 'QliqDIRECT',
    isEmrIntegrationSubscribed: 'EMR Integration',
    isMessagingApiSubscribed: 'Messaging API',
    isWctpApiSubscribed: 'WCTP API',
    isVisitPathWebhookSubscribed: 'Visit Path Webhook',
    isQuincyApiSubscribed: 'Quincy API',
    isReportsApiSubscribed: 'Reports API',
    isUsageLimitsEnabled: 'Usage Limits',
    isIframeApiEnabled: 'Iframe API',
    isIframeVcEnabled: 'QuincyCHAT',
    isIframeVpEnabled: 'Visit Path',
    isOtherCategoryEnabled: 'Others category',
    isQuincyCategoryEnabled: 'Quincy category',
    isQliqChatCategoryEnabled: 'QliqCHAT category',
    isOauthEnabled: 'AuthO',
    isSftpArchiveEnabled: 'SFTP Archive',
    isThirdPartyIntegrationSubscribed: 'Third Party Integrations',
    isAnnouncementsSubscribed: 'Announcements',
    isNiceIntegrationSubscribed: 'NICE Integration',
    isOrderTemplatesSubscribed: 'Orders',
    isIfaxIntegrationSubscribed: 'iFax Integration',
    isAxxessIntegrationSubscribed: 'Axxess Integration',
    isScreensharingCallsSubscribed: 'Screen Sharing',
    isAiSummarizationSubscribed: 'AI Summarization',
    isQuincyChatSubscribed: 'QuincyCHAT',
  },

  fields: {
    newEmailAddress: 'New email address',
    confirmNewEmailAddress: 'Confirm new email address',
    resetPasswordFlag: 'Generate/Choose Password',
    resetPasswordFlagDescr:
      'Checking this flag is going to generate a random password for the user. You can override the generated password by editing the text with the password that the user can remember.',
    sendMobileMessageTo: 'Send Mobile Message To',
    sendMessageTo: 'Send Message To',
    firstName: 'First Name',
    mi: 'MI',
    lastName: 'Last Name',
    mobilePhone: 'Mobile Phone',
    maskFromContacts: 'Mask from Contacts',
    title: 'Title',
    allowMobileLogin: 'Allow Mobile App Login',
    confirmationLink: 'Confirmation Link',
    resendInvitationWarningDesc:
      'In the event that invitation emails are not getting delivered, simply copy the following link and send it from your work email client.',
    confirmationURL: 'Confirmation URL',
    generatePassword: 'Generate Password',
    password: 'Password',
    sendEmail: 'Send email to user',
    emailSubject: 'Personalize Email Subject',
    emailSubjectPlaceholder: 'Join Qliq for HIPAA Compliant Texting',
  },

  hasSucceeded: 'Success',
  resetPasswordFor: 'Reset Password for',

  errors: {
    pageDoesntExist: "The page you were looking for doesn't exist.",

    internalServerError: {
      serverErrorTitle: 'Internal Server Error',
      serverErrorDescription:
        'Something went wrong while processing your request',
      serverErrorUserMessage:
        'Service should be up and running shortly, please check back later.',
    },

    notImplemented: {
      serverErrorTitle: 'Not Implemented',
      serverErrorDescription:
        'The server does not support the functionality required to fulfill the request.',
      serverErrorUserMessage:
        'This feature is not yet available. Please contact support for further information.',
    },

    badGateway: {
      serverErrorTitle: 'Bad Gateway',
      serverErrorDescription:
        'The server received an invalid response from an upstream server.',
      serverErrorUserMessage:
        "We're experiencing connectivity issues with our servers. Please try again shortly.",
    },

    serviceUnavailable: {
      serverErrorTitle: 'Service Unavailable',
      serverErrorDescription:
        'The server is temporarily unable to handle the request due to maintenance or overload.',
      serverErrorUserMessage:
        "Our service is temporarily unavailable. We're working to resolve this issue. Please try again later.",
    },

    gatewayTimeout: {
      serverErrorTitle: 'Gateway Timeout',
      serverErrorDescription:
        'The server did not receive a timely response from an upstream server.',
      serverErrorUserMessage:
        'The request took too long to process. Please refresh the page or try again later.',
    },

    httpVersionNotSupported: {
      serverErrorTitle: 'HTTP Version Not Supported',
      serverErrorDescription:
        'The server does not support the HTTP protocol version used in the request.',
      serverErrorUserMessage:
        'The requested protocol version is not supported. Please update your application and try again.',
    },
    quickForm: {
      complete: 'Failed to complete quick form',
    },
  },

  appointmentStatuses: {
    0: 'Booked',
    1: 'Canceled',
    2: 'No show',
    3: 'Completed',
    4: 'Confirmed',
    5: 'No show likely',
  },

  sidebarTooltips: {
    bd: 'Chat Bots',
    cc: 'Care Campaigns',
    cw: 'Chat Widgets',
    faq: 'FAQs',
    gp: 'AI Agents',
    gs: 'Group Settings',
    oc: 'Oncall Schedules',
    qf: 'Quick Forms',
    qs: 'Quick Sign',
    rp: 'Reports',
    ss: 'Self Schedules',
    vc: 'QuincyCHAT',
    vp: 'Visit Path',
    openInNewTab: 'Open {tab} in a new tab',
  },

  usTimezone: {
    pacific: '* Times are in Pacific Time (PT)',
    mountain: '* Times are in Mountain Time (MT)',
    central: '* Times are in Central Time (CT)',
    eastern: '* Times are in Eastern Time (ET)',

    pacificDaylight: '* Times are in Pacific Daylight Time (PDT)',
    mountainDaylight: '* Times are in Mountain Daylight Time (MDT)',
    centralDaylight: '* Times are in Central Daylight Time (CDT)',
    easternDaylight: '* Times are in Eastern Daylight Time (EDT)',
  },

  codeErrors: {
    GS_CANNOT_REMOVE_LAST_OWNER: `This member can't be removed.`,
    GS_CANNOT_SELF_REMOVE_LAST_GROUP:
      "Can't remove yourself from your last group",
    PC_UNKNOWN_PATIENT: 'Cannot schedule for unknown patient',
    SS_RESOURSE_NAME_ALREADY_TAKEN: 'Resource name already exists.',
    GP_WORKPLACE_NAME_ALREADY_TAKEN: 'AI Agent name already exists.',
    GP_DOCUMENT_NAME_ALREADY_TAKEN:
      'Duplicate file detected. Remove or rename before uploading.',
    CC_SFTP_CONFIG_IS_NOT_ACTIVE: 'Sftp config is not active.',
    CC_NO_SFTP_SOURCE_IS_CONFIGURED: 'No sftp source is configured.',
    CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED:
      'No sftp recipient source is configured.',
    CC_CHANGE_WILL_CAUSE_DUPLICATES: `This {personType} is already in the group`,
    SA_CANNOT_REMOVE_LAST_SUPEROWNER: "The last super owner can't be removed",
    SA_CANNOT_REMOVE_SELF:
      'Action Denied: You cannot remove yourself from this account',
    PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION:
      'Auto Campaign is not active',
    CC_AUTO_CAMPAIGN_IS_EXPIRED: 'Auto Campaign is expired',
    CW_OAUTH_IS_NOT_CONFIGURED: 'OAuth not configured, please contact support',
    CC_AUTO_CAMPAIGN_MESSAGE_SEQUENCE_IS_INCOMPLETE:
      'Message sequence is incomplete',
    QW_KEY_NOT_FOUND:
      'Encryption keys are missing. Some messages may be unavailable. Please log in again to restore access.',
    SIP_MISSMATCHED_X_HASH:
      'For security reasons, your credentials were updated after changing your password. Contact support for help.',
  },

  noAvatar: 'No Avatar',

  sortTypes: {
    name: 'Name',
    state: 'Status',
    updated_at: 'Modified',
  },

  tableCustomSelection: {
    deleteSelected: 'Delete selected',

    tooltip: 'Actions',
  },

  dayPeriod: {
    AM: 'AM',
    PM: 'PM',
  },

  statusInfo: {
    submitted: 'Submitted',
    uploading: 'Uploading',
    opened: 'Opened',
    uploadFailed: 'Upload Failed',
    uploaded: 'Uploaded',
    abandoned: 'Abandoned',
    outstanding: 'Outstanding',
    errored: 'Errored',
    paid: 'Paid',
    deleted: 'Deleted',
    created: 'Created',
    sent: 'Sent',
    abandonedFormsTooltip:
      'Forms that are not submitted for more than 1 hour after opening.',

    booked: 'Booked',
    completed: 'Completed',
    canceled: 'Canceled',
    confirmed: 'Confirmed',
    noShows: 'No Show',
    delivered: 'Delivered',
    no: 'No',
    yes: 'Yes',
    noShowLikely: 'No Show Likely',
    success: 'Success',
    failed: 'Failed',
    serverError: 'Server Error',
    noPayment: 'No Payment',
    partialPayment: 'Partial Payment',
    fullPayment: 'Full Payment',
    emailSent: 'Notifications Email',
    webhook: 'Webhook',
    sftp: 'SFTP Uploads',
  },

  notificationBanner: {
    message: 'You are over the limit. Additional charges may apply.',
    messageLimitReached: 'You reached the limit. Additional charges may apply.',
    viewUsageButton: 'View Usage',
  },

  limitTrendDialog: {
    title: 'Trend',
  },

  usageLimitsLabels: {
    exportHeader: 'Select a Month Range to Export',
    quincyTitle: 'Quincy',
    qliqChatTitle: 'QliqCHAT',
    textInside: 'No Limits',

    agent: 'Agents',
    autoCampaign: 'Auto Campaigns',
    plusSign: 'Plus Sign',
    plusForm: 'Plus Form',
    campaign: 'Campaigns',
    chatBot: 'Chatbots',
    chatWidget: 'Widgets',
    conversation: 'Conversations',
    encounter: 'Self Schedules',
    faq: 'FAQs',
    formSubmission: 'Quick Form Submissions',
    member: 'Members',
    mmsMessage: 'MMS Messages',
    nonMember: 'Non-Members',
    onCallGroup: 'OnCall Groups',
    onCallCall: 'OnCall Calls',
    recipient: 'Recipients',
    recipientGroup: 'Recipient Groups',
    schedulableResource: 'Self Schedule Resources',
    smsTextMessage: 'SMS Text Messages',
    snapAndSign: 'Snap and Sign',
    unknownType: 'Unknown Type',
    videoCall: 'Video Calls',
    virtualVisit: 'Video Visits',
    visitPathUser: 'Visit Path Users',
    quickSignDocument: 'Quick Sign Documents',
    quickForm: 'Quick Forms',
    qliqAssistedCall: 'Qliq Assisted Calls',
    updateLimits: 'Limits Updated Successfully',
    quickSigntemplate: 'Quick Sign Templates',
    screenSharing: 'Screen Sharing',
    aiSummarization: 'AI Summarization',

    hard: 'Hard limit',
    soft: 'Soft limit',
    unlimited: 'Unlimited',

    cumulative: 'Max',
    periodic: 'Monthly',

    notifications: {
      title: 'Notification Settings',
      isEmailSupport: "Email to support{'@'}qliqsoft.com",
      isEmailOwners: 'Email to Group Owners',
      isBannerOwners: 'Banner for Group Owner to take action',
      isBannerAgents: 'Banner for Agents and Users',
    },
  },

  personType: {
    unknown: 'Unknown',
    caregiver: 'caregiver',
    client: 'client',
    clinician: 'clinician',
    nurse: 'nurse',
    patient: 'patient',
    physician: 'physician',
    provider: 'provider',
    technician: 'technician',
    therapist: 'therapist',
    member: 'member',
    employee: 'employee',
  },

  patientSex: {
    0: '',
    1: 'Male',
    2: 'Female',
  },

  timeType: {
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
  },

  initiationType: {
    unknown: 'Unknown',
    careCampaign: 'Care campaign',
    autoCampaign: 'Auto campaign',
    plusChat: '+Chat',
    qrCode: 'QR code',
    websiteUrl: 'Website URL',
    agent: 'Agent',
  },

  twoFactorAuthentication: {
    title: 'Two Factor Authentication',
    shortTitle: '2FA',
    edit: 'Edit 2FA for {name}',
    enable: 'Enable Two-Factor Authentication (2FA)',
    preferredMethod: '2FA Preferred method:',
    qliqId: 'Qliq Id:',
    email: 'Email:',
    mobilePhone: 'Mobile phone',
    verified: 'verified',
    reLink: 'Re-link',
    linkAuthenticatorApp: 'Link Authenticator App',

    statusOptions: {
      disabled: 'Disabled. Do not require a verification code.',
      oncePerComputer:
        'Once per computer. Trust computers and only ask for verification code every 30 days.',
      everyLogIn: 'Every log-in. We will always ask for verification code.',
    },
    superAdminDisableError: 'Super Admin cannot disable 2FA',

    methodOptions: {
      email: 'Email',
      smsText: 'SMS Text',
      authenticator: 'Authenticator',
    },

    authenticatorModal: {
      title: 'Link the Authenticator App to your QliqSoft Account',
      supportedApps: 'Supported Authenticator Apps:',
      googleAuthenticator: 'Google Authenticator',
      twillioAuthy: 'Twillio Authy',
      openAuthenticationApp:
        'Open the authentication app on your mobile device to link it to your Qliqsoft account. When the app prompts you, scan the following QR code down below or enter this code <strong>{secret}</strong>',
    },

    verifyPhoneNumberModal: {
      title: 'Mobile Phone Verification',
      phoneNumber: 'Phone Number: {phone}',
      resendCode: 'Resend Code',
      sendCode: 'Send code',
      error: 'Verification Code Incorrect',
    },

    saved: 'Saved!',
    someError: 'Something went wrong',
  },

  statusesType: {
    archived: 'Archived',
    assignedToBot: 'Assigned To Bot',
    canceled: 'Canceled',
    close: 'Close',
    duplicate: 'Duplicate',
    escalated: 'Escalated',
    invited: 'Invited',
    noReply: 'No Reply',
    open: 'Open',
    spam: 'Spam',
    unassigned: 'Unassigned',
    booked: 'Booked',
    completed: 'Completed',
    confirmed: 'Confirmed',
    noShows: 'No Show',
    noShowLikely: 'No Show Likely',
  },

  botcastsStatusesType: {
    unknown: 'Unknown',
    queued: 'Queued',
    sent: 'Sent',
    notValid: 'Not Valid',
    failed: 'Failed',
    delivered: 'Delivered',
  },

  webhookEventType: {
    unknown: 'Unknown',
    termsAndConditions: 'Terms And Conditions',
    newMessage: 'New Message',
    messageStatus: 'Message Status',
    invitationSent: 'Invitation Sent',
    csvImport: 'CSV Import',
    patientAuthentication: 'Patient Authentication',
    formSubmission: 'Form Submission',
    formSubmissionAsPdf: 'Form Submission As PDF',
    quickSignSubmissionsAsPdf: 'Quick Sign Submission As PDF',
    formOpened: 'Form Opened',
    botFinished: 'Bot Finished',
    botAbandoned: 'Bot Abandoned',
  },

  recipientType: {
    unknown: 'unknown',
    patient: 'patient',
    visitor: 'visitor',
    user: 'user',
    bot: 'bot',
  },

  botcastRecipientType: {
    unknown: 'Unknown',
    email: 'Email',
    textPhone: 'SMS',
    voicePhone: 'Voice',
  },

  usageLimitTimeStepOptions: {
    HOUR: 'Hour',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    YEAR: 'Year',
  },

  submissions: {
    exportCsvWaring: 'Only one form can be selected to export',
    formUploadScheduled: 'Form submission upload scheduled',
    completed: 'Quick Form has been successfully completed',
    submitError: 'Quick Form submission failed',
    eventTypes: {
      SENT: 'Sent',
      OPENED: 'Opened',
      SUBMITTED: 'Submitted',
      UPLOADING: 'Uploading',
      UPLOADED: 'Uploaded',
      UPLOAD_FAILED: 'Upload Failed',
      EMAIL_SENT: 'Email Notification Sent',
      WEBHOOK_SENT: 'Webhook Sent',
    },
    by: 'By',
    to: 'To',
  },

  quickFormEditor: {
    brokenImagePath: 'Failed to load image',
    loadingImage: 'Loading Image',
    type: 'Type',
    searchPlaceholder: 'Search Form',
    allForms: 'All',
    submissionTableMessages: {
      noEmailAdress: 'No email adress',
      noWebhookUrl: 'No webhook url',
      noEmailSubject: 'No Email Subject',
    },
    tabs: {
      formSubmissions: 'Form Submissions',
      webhookCalls: 'Webhook Calls',
      emailNotifications: 'Email Notifications',
    },
    quickForms: 'Quick Forms',
    templates: 'Form Templates',
    forms: 'Forms',
    filters: {
      forms: 'Forms',
      status: 'Status',
      searchPatients: 'Search Patients',
    },
    filterBy: 'Filter by Date',
    clearFilters: 'clear filters',
    tableFields: {
      formName: 'Form Name',
      submittedBy: 'Submitted By',
      openedAt: 'Opened At',
      submittedAt: 'Submitted At',
      status: 'Status',
      timeTaken: 'Time Taken',
      submission: 'Submission',
      last: 'Last',
      webhookURL: 'Webhook URL',
      submissionTime: 'Submission Time',
      subject: 'Subject',
      address: 'Address',
    },
    visitor: 'Visitor',
    total: 'Total',
    confirmDeletion: {
      title: 'Confirm Deletion',
      deletingText:
        'Are you sure you want to delete {name}? You cannot undo this action.',
    },
    submissions: {
      title: 'Submissions',
    },
    formName: 'Form Name',
    label: 'Label',
    buttons: {
      newField: 'New Field',
      newSubform: 'New Subform',
      existingSubform: 'Existing Subform',
      close: 'Close',
      closeLogic: 'Close Logic',
      condition: 'Condition',
      addSubForm: 'Add subform',
      create: 'Create',

      conditionalLogic: 'Conditional Logic',
      preview: 'Preview',
      webhookMapping: 'Webhook mapping',
      customization: 'Customization',
      translations: 'Translations',

      closePreview: 'Close preview',
      closeConditionalLogic: 'Close Conditional Logic',
      closeTranslations: 'Close Translations',
      closeWebhookMapping: 'Close Webhook mapping',
      closeCustomization: 'Close Customization',
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      strike: 'Strike',
      link: 'Link',
      image: 'Image',
      video: 'Video',
      clean: 'Clean',
      blockquote: 'Blockquote',
      headerLarge: 'Header 1',
      headerMedium: 'Header 2',
      codeBlock: 'Code-block',
      orderedList: 'Ordered list',
      bulletList: 'Bullet list',
      subText: 'Sub text',
      superText: 'Super text',
      intentMinusText: 'Intent text -1',
      intentPlusText: 'Intent text +1',
      direction: 'Text direction',
      align: 'Align',
      color: 'Color',
      background: 'Background',
      undo: 'Undo',
      redo: 'Redo',
      code: 'Code',
    },
    customization: {
      title: 'Customization',
      cardTitle: 'Fill in the Form Button',
      description:
        'You can write custom text for your Fill in the Form button here',
      autoTranslate: 'Auto-translate',
      autoTranslateTooltip:
        "Enabling will translate the text automatically. You will be able to verify and edit in the 'Translate' tab",
      inputPlaceholder: 'Example: Click here to open form',
      btnCustomizeText: "You can customize your button's color",
      shapeCustomize: 'You can also customize the shape of your button',
      info: 'The start button allows for a customized icon prepended or appended to the text. You may also choose to have no text with just an icon as the button!',

      customizationBtns: {
        text: 'text',
        rounded: 'rounded',
        outlined: 'outlined',
        tile: 'tile',
      },

      animatedBtn: 'Animate the Start Button',

      color: 'Color',
      colorTooltip: 'Default chat widget Color code is {color}',

      messagesExample: {
        msg1: 'Welcome to Memorial Care Guide',
      },
      botName: 'Memorial Care Guide',

      successMessage: 'Customization was successfully saved',
    },
    conditionalLogic: {
      title: 'Conditional Logic',
      insurancePicture: 'Take a picture of your insurance card',
      showIf: 'Show if',
      andIf: 'And if',
      orIf: 'Or if',
      chooseConditions:
        'You can choose what conditions are required for a field or subform to be visible',
      selectFieldOrSubform: 'Select a field or subform',
      selectConditionField: 'Select field or attribute',
      selectField: 'Select a field',
      youNeedSpecialFields:
        'In order to be able to add conditional logic, you must first add a field with the type Number, Pain Scale, Boolean, or Radio Buttons.',
    },
    translation: {
      translateTooltip: 'Click to translate all the fields below',
      english: 'English (US)',
      option: 'Option {index}',
      hint: 'Hint {index}',
    },
    webhookMapping: {
      originalName: 'Original name',
      webhookName: 'Webhook name',
    },
    submissionFilters: {
      startDate: 'Start date',
      endDate: 'End Date',
      to: 'to',
    },
    configurationButtons: {
      save: 'save',
      discard: 'discard',
      addOption: 'Add Option',
    },
    configurationFields: {
      name: 'Name',
      isEnabled: 'Enabled',
      isEnabledIf: 'Enabled If',
      isRequired: 'Required',
      isAutofill: 'Autofill current date',
      isAutofillTime: 'Autofill current time',
      isNumbers: 'Numbers',
      isYearFirst: 'Year First (For DoB and distant dates)',
      isRow: 'Row',
      isDefaultTrue: 'Checked',
      isDefaultTrueIf: 'Checked if',
      hint: 'Hint',
      isRequiredAllToBeChecked: 'Require all to be checked',
      isRequireAtLeastOne: 'Require at least one',
      isSelectAllEnabled: 'Select All',
      optionIndex: 'Option #{index}',
      typeOption: 'Type an option here',
      pullFrom: 'Pull From',
      saveAs: 'Save as key',
      format: 'Format',
      firstDay: 'First day of week',
      isCustomBp: 'Custom BP Gates',
      max: 'Maximum value',
      min: 'Minimum value',
      maxLength: 'Maximum Length',
      minLength: 'Minimum Length',
      isMultiple: 'Multiple Files',
      accept: 'Specific Kind',
      reset: 'Reset',
      images: 'Images',
      videos: 'Videos',
      documents: 'Word Documents',
      pdfs: 'PDFs',
      isSelectAll: 'Select All',
    },
    systolicKeys: {
      systolicMinimum: 'Systolic Minimum',
      systolicLow: 'Systolic Low',
      systolicIdeal: 'Systolic Ideal',
      systolicPreHigth: 'Systolic Pre-High',
      systolicMax: 'Systolic Maximum',
    },

    diastolicKeys: {
      diastolicMinimum: 'Diastolic Minimum',
      diastolicLow: 'Diastolic Low',
      diastolicIdeal: 'Diastolic Ideal',
      diastolicPreHigth: 'Diastolic Pre-High',
      diastolicMax: 'Diastolic Maximum',
    },
    cardTitle: {
      configuration: 'Configuration',
      preview: 'Preview',
    },
    allowSubformRepeat: 'Allow users to respond several times to this subform',
    config: {
      address_field: 'Address',
      boolean: 'Boolean',
      blood_pressure: 'Blood Pressure',
      checklist: 'Check-List',
      date: 'Date',
      datetime: 'Date + Time',
      dosage: 'Dosage',
      html_select: 'Drop-down',
      email: 'Email',
      frequency: 'Frequency',
      html_number: 'Number',
      pain_scale: 'Pain Scale',
      phone_number: 'Phone Number',
      radio_buttons: 'Radio Buttons',
      ratings: 'Ratings',
      signature: 'Signature',
      notice: 'Notice',
      markdown: 'Markdown',
      html_text: 'Text',
      html_time: 'Time',
      file: 'Upload a File',
      weight: 'Weight',
    },
    existingSubForm: {
      title: 'Add Existing Subform',
    },
    subform: 'Subform Name',
    emptyState: {
      title: 'No fields in',
      addField: 'Add a Field',
    },
    formRequestAnswers: {
      createSuccess: 'The form has been successfully created.',
      deleteSuccess: 'The form has been successfully deleted.',
      updateSuccess: 'The form has been successfully updated.',
    },
    fieldRequestAnswers: {
      createSuccess: 'The field has been successfully created.',
      deleteSuccess: 'The field has been successfully deleted.',
      updateSuccess: 'The field group has been successfully updated.',
    },
    formNameNotUniq: 'Name must be unique',
    copyForm: {
      title: 'Copy the Form',
      copyWithinGroup: 'Copy within group',
      selectDestination: 'Select destination ',
      destinationTooltip:
        'You need to be an owner for both, the source and the destination group, to be able to copy a Form',
      selectGroup: 'Select the group to paste the copied form',
      success: '{name} has been copied over to {group} group successfully',
    },
  },

  userRoles: {
    UNKNOWN_ROLE: '',
    OWNER: 'Owner',
    ADMIN: 'Admin',
    AGENT: 'Agent',
    MEMBER: 'Group Member',
    NON_MEMBER: 'Non Member',
  },

  emailSettings: {
    title: 'Email Settings',
    inputs: {
      subject: 'Subject',
      email: 'Email Address',
      hasEmptyEmailInput:
        'You already have empty email field. Fill in or remove it first.',
    },
    buttons: {
      addAddress: 'Add Address',
      save: 'save',
      reupload: 'reupload',
      upload: 'upload',
      printForm: 'Print Form',
    },
    errors: {
      invalidEmail: 'Invalid email address.',
      requiredEmail: 'Email is required',
    },
  },

  addressField: {
    unableAddress: 'Unable to find address',
  },

  templateForm: {
    create: 'Create a template',
    choose: 'Choose the form from which the template will be created',
  },

  uploadActivity: {
    title: 'Upload Activity',

    table: {
      qliqId: 'Qliq Id',
      callId: 'Call Id',
      name: 'Name',
      type: 'Type',
      fileName: 'File Name',
      fileSize: 'File Size',
      created: 'Created At',
      cloudReceived: 'Cloud Received At',
      qliqStoreReceived: 'QliqSTOR Received At',
      qliqStoreConfirmed: 'QliqSTOR Confirmed At',
      qliqStoreStatus: 'Status',
    },
    statuses: {
      accepted: 'Accepted',
      blocked: 'Blocked',
      confirmed: 'Confirmed',
    },
  },

  labels: {
    patient: '{personType}',
    resource: 'Resource',
    viewTracker: 'View tracker',
    tac: 'Terms and conditions',
    faq: 'FAQs',
    writeReply: 'Write a reply',
    translate: 'Translate',
    chooseDate: 'Choose a date',
    copyWithinGroup: 'Copy within group',
    copyWithinSubgroup: 'Copy within subgroup',
    selectDestination: 'Select destination',
    group: 'Group',
    subgroup: 'Sub Group',
    beta: 'This section of the report is still under construction',
    startDate: 'Start Date',
    endDate: 'End Date',
    searchFaqs: 'Search FAQs',
    dob: 'Date of Birth',
    date: 'Date',
    confirmDeletion: 'Confirm Deletion',
    resetFilters: 'Reset Filters',
    all: 'All',
  },

  fillInTheForm: 'Fill in the Form',

  emoji: {
    people: 'People',
    nature: 'Nature',
    places: 'Places',
    objects: 'Objects',
    sybmols: 'Sybmols',
    find: 'Find emoji',
  },

  validations: {
    notJustSpaces: 'Field cannot contain only spaces',
    duplicateColumn: 'Mapped to more than one field',
    hexColor: 'Invalid hex color',
    invalid: 'Invalid value',
    invalidInput: 'Invalid input',
    timezone: 'Invalid timezone',
    maxLength: '{name} must be {max} characters or fewer.',
    portNumber: {
      invalid: 'Invalid port number',
    },
    ipAddress: {
      invalid: 'Invalid IP address',
    },
    sftpHost: {
      invalid: 'Invalid host',
    },
    duration: {
      required: 'Duration is required',
      invalid: 'Invalid duration',
      max: 'Duration must be less than {max} {unit}',
      positive: 'Duration cannot be negative',
    },
    folderPath: {
      invalid: 'Invalid path to folder',
      slashEnding: 'Path must end with a slash symbol "/"',
    },
    signature: {
      required: 'Signature is required',
    },
    widget: {
      required: 'Widget is required',
    },
    option: {
      required: 'Please select an option',
      select: 'Select',
    },
    dosage: {
      required: 'Dosage is required field',
      invalidDose: 'Invalid dose',
    },
    unit: {
      required: 'Please select a unit',
    },
    systolic: {
      required: 'Systolic value is required',
    },
    diastolic: {
      required: 'Diastolic value is required',
    },
    address: {
      required: 'Address is required field',
    },
    zipCode: {
      required: 'Zip code is required field',
    },
    city: {
      required: 'City is required field',
    },
    stateCode: {
      shortCode: 'State Code must Be 2 Letters',
    },
    state: {
      required: 'State is required field',
    },
    patient: {
      required: 'Please select a patient',
    },
    subject: {
      required: 'Please input a subject',
    },
    firstName: {
      required: 'Please input a first name',
      invalid: 'Please enter correct first name',
    },
    lastName: {
      required: 'Please input a last name',
      invalid: 'Please enter correct last name',
    },
    fullName: {
      required: 'Please input a full name',
      invalid: 'Please enter First and Last name',
    },
    email: {
      required: 'Email Required',
      invalid: 'Please input a valid email',
      match: 'Emails must match',
      emailSameToPrevious: 'New email is the same as current email',
      emailConfirmation: "Email doesn't match confirmation.",
    },
    password: {
      required: 'Password is required',
      invalid: 'Please enter a valid password',
      match: 'Passwords must match',
    },
    mrn: {
      invalid: 'Please input a valid mrn',
    },
    patientGroups: {
      invalid: 'Please input a valid patient groups',
    },
    dob: {
      required: 'Dob Required',
      invalid: 'Please input a valid dob',
    },
    sex: {
      required: 'Sex at Birth Required',
    },
    startTime: {
      required: 'Start time Required',
    },
    startDate: {
      required: 'Start date Required',
      invalid: 'Invalid format of the date',
      pastDate: 'Invalid date. The date cannot be in the past',
    },
    endTime: {
      required: 'End time Required',
    },
    inputTime: {
      required: 'Please input a time',
      invalid: 'Invalid format of the time',
    },
    provider: {
      required: 'Provider Required',
    },
    mobileNumber: {
      required: 'Phone Number Required',
      notValid: 'Number not valid',
      invalid: 'Please enter a valid phone number',
      invalidCountryCode: 'Please enter a valid phone number with country code',
      notTextable: 'Number not Textable',
      typeError: 'Choose type of phone number',
    },
    callerId: {
      required: 'Caller Id Required',
    },
    smsSubject: {
      required: 'Please input a subject',
    },
    number: 'Value must be a number',
    numberBetween: 'A value should be more than {min} and less than {max}',
    numberMin: 'A value should be more than {min}',
    numberMax: 'A value should be less than {max}',
    checkboxes: {
      requiredAll: 'Must check all items',
      atLeastOne: 'You have to check at least one',
    },

    date: {
      required: 'Please select a date',
      invalid: 'Invalid date',
      invalidYear: 'Incorrect Year in date field',
      invalidMonth: 'Incorrect Month in date field',
      invalidDay: 'Incorrect Day in date field',
      invalidHour: 'Incorrect Hour in time field',
      invalidMinute: 'Incorrect Minute in time field',
      inFuture: 'Invalid date. The date cannot be in the future',
      inPast: 'Invalid date. The date cannot be in the past',
      formatYyyMmDd: 'Invalid date format. Use `Year, month, day` format',
    },
    time: {
      required: 'Please select a time',
    },
    text: {
      max: 'A value must not have more than {max} characters',
      min: 'A value must not have less than {min} characters',
    },
    file: {
      required: 'Please select a file',
      maxSize: 'File to big for upload (max size of {max}MB)',
      compressionMaxSize:
        'File to big for upload even after compression (max size of {max}MB)',
      compress: 'Compressing error',
      noFile: 'No files uploaded',
    },
    required: 'Field is required',
    passwordMismatch: 'Passwords do not match',
    requiredCheck: 'Checkbox is required',
    search: {
      atLeast: 'At least {count} characters',
    },
    language: 'Please, select a language',
    service: 'Please, select a service',
    domain: {
      invalid: 'Should match domain pattern',
    },
    length: 'The value must contain {count} characters',
    alphaNumeric: 'The value can contain only alphanumeric characters',
    name: {
      unique: 'The name should be unique',
    },
    weight: {
      invalidWeight: 'Invalid weight',
    },
    customAttributes: {
      name: {
        required: 'Attribute name is required',
        min: 'Attribute name must not have less than {min} characters',
        nameFormatIsIncorect: 'Name format is incorrect',
      },
      key: {
        required: 'Variable name is required',
        min: 'Variable name must not have less than {min} characters',
      },
    },
    dynamic: {
      required: '{field} is required',
    },
    frequency: {
      required: 'Must specify',
      pickOne: 'Pick one',
    },
    bot: {
      inactiveState: 'Bot is stopped, select another option',
    },
  },

  timeUnits: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    length: 'A value should contain {count} characters',
    yesterday: 'Yesterday',
    today: 'Today',
  },

  popconfirm: {
    yes: 'YES',
    no: 'NO',
  },

  buttons: {
    createNew: 'Create new',
    savePlusNew: 'Save + New',
    submit: 'Submit',
    schedule: 'Schedule',
    view: 'View',
    fill: 'Fill',
    fillForm: 'Fill the form',
    submitted: 'Submitted',
    complete: 'Complete',
    sign: 'Sign',
    signDocument: 'Sign the document',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    preview: 'Preview',
    deploy: 'Deploy',
    clear: 'Clear',
    delete: 'Delete',
    save: 'Save',
    search: 'Search',
    saveChanges: 'Save Changes',
    verify: 'Verify',
    verified: 'Verified',
    discard: 'Discard',
    agree: 'Agree',
    disagree: 'Disagree',
    deleteChat: 'Delete chat widget',
    discardChanges: 'Discard changes',
    close: 'Close',
    add: 'Add',
    addDates: 'Add Dates',
    apply: 'Apply',
    discardAllChanges: 'Discard All Changes',
    previous: 'Previous',
    next: 'Next',
    exportCSV: 'Export to CSV',
    importCSV: 'Import via CSV',
    back: 'Back',
    send: 'Send',
    uploadFile: 'Upload File',
    export: 'export',
    create: 'create',
    done: 'Done',
    confirm: 'Confirm',
    invite: 'Invite',
    removeAgent: 'remove agent',
    userGuide: 'User Guide',
    adminGuide: 'Admin Guide',
    troubleShooting: 'Trouble Shooting',
    learningCenter: 'The Learning Center',
    announcement: 'Announcement',
    chooseFile: 'Choose File',
    downloadSampleCSV: 'Download sample {index} CSV',
    reset: 'Reset',
    addToCalendar: 'Add to calendar',
    change: 'Change',
    update: 'Update',
    removeSelected: 'Remove Selected',
    acceptSelected: 'Accept Selected',
    demo: 'Demo',
    login: 'Login',
    uploadAvatar: 'Upload Avatar',
    uploadLogo: 'Upload Logo',
    remove: 'Remove',
    review: 'Review',
    resolve: 'Resolve',
    invalidate: 'Invalidate',
    markDuplicate: 'Mark as duplicate',
    download: 'Download',
    authenticate: 'Authenticate',
    reAuthenticate: 'Re-authenticate',
    messages: 'Messages',
    deleteChatWidget: 'Delete Chat Widget',
    edit: 'Edit',
    ok: 'OK',
    book: 'Book',
    sendMessage: 'Send Message',
    sendInvite: 'Send Invite',
    paste: 'Paste',
    import: 'Import',
    generate: 'Generate',
    copyToClipboard: 'Copy to clipboard',
    print: 'Print',
    closeTranslate: 'Close translate',
    scrollDown: 'Scroll Down to accept',
    start: 'Start',
    deleteAll: 'Delete All',
    select: 'Select',
    open: 'Open',
    resetFilters: 'Reset Filters',
    train: 'Train',
    accept: 'Accept',
    deny: 'Deny',
    hold: 'Hold',
  },

  chat: {
    patient: 'Patient',
    creator: 'Creator',
    visitor: 'Visitor',
    unknownUser: 'Unknown User',
    you: 'You',
    tooltip: {
      microphoneMute: 'Microphone Mute',
      microphoneUnmute: 'Microphone Unmute',
      leaveScreenSharing: 'Leave Screen Sharing',
      leaveCall: 'Leave Call',
      switchCamera: 'Switch Camera',
      disableCamera: 'Disable Camera',
      enableCamera: 'Enable Camera',
    },
    labels: {
      videoCall: 'Video Call',
      voiceCall: 'Voice Call',
      screenSharing: 'Screen Sharing',
      uploadToEmrButton: 'Upload to EMR',
      dropFileCSV: 'Drag and drop your CSV',
      dropFile: 'Drag and drop File',
      nextField: 'Go to the next field to fill in',
      startFill: 'Start filling in the fields',
      enterName: 'Enter a Name',
      enterDate: 'Enter Date',
      enterInitials: 'Enter Initials',
      withAttachment: '( with attachment )',
      receivedAttachment: 'You received an attachment',
      translationError: 'Cannot translate text',
      oneFilePerMessage: 'Only one attachment per message is supported',
      attachmentFileLimit: 'Attachment must be smaller than {size} MB',
      attachmentFileTypeInvalid: 'Invalid File format',
      agent: 'Agent',
      bot: 'Bot',
      patient: 'Patient',
      noUnreadMessage: 'Cannot find unread message',
      searchAgentBot: 'Search Agent/Bot',
      notAssigned: 'Not assigned',
      noConversationDescription:
        'Add New patients and interact with them through text or video chat.',
      reassignForbid:
        'Changing a conversation assignee is forbidden for the closed conversations.',
      screenShareForbidden:
        'You cannot start a Screen Shaing unless the conversation is assigned to you',
      callForbidden:
        'You cannot start a Video or Audio Chat unless the conversation is assigned to you',
      screenSharingDisabled:
        'The Screen Sharing feature has been disabled. Please reach out to the Group Admin to activate this feature',
      callDisabled:
        'The Telephony (Voice Calls) feature has been disabled. Please reach out to the Group Admin to activate this feature',
      emrUploadForbidden:
        'The EMR uploads feature has been disabled. Please reach out to the Group	Admin to activate this feature.',
      emrWorkflowInactive:
        'To enable upload, update Quick Form EMR Upload Settings.',
      emrUploadExcluded: 'This feature is not enabled for this EMR.',
      socketDisconnectedReload:
        'Chat connection lost. Please refresh the page to restore.',
      socketDisconnectedIssue:
        'Server connection issue, please try again later',
      interpreterLabel: 'Interpreter',
      visitor: 'Visitor',
      updatePatient: 'Update {personType}',
      noEmoji: 'There are no emojis with entered name',
      createPatient: 'Create a patient',
      findConversation: 'Find conversation',
      reassign: 'Reassign',
      chat: 'Chat',
      startConversation: 'Start Conversation',
      startAConversation: 'Start a Conversation',
      invitationSentSuccess: 'Invitation Sent Successfully',
      dontShowItAgain: 'Don`t show this again',
      waitingRoom: 'Waiting Room',
      invitesSent: 'Invites Sent',
      selectPatient: 'Select a patient',
      onlyMyPatients: 'To search only your patients',
      myPatients: 'My {personType}s',
      createPrivateConversation:
        'Enable this option to make the conversation private. Other agents will not have access to this conversation.',
      privateConversation: 'Private Сonversation',
      textSubject: 'Text subject',
      emailSubject: 'Email subject',
      emailContent: 'Email body',
      workNumber: 'Work number',
      mobileNumber: 'Mobile number',
      usCode: '+1',
      code: 'Code',
      status: 'Status',
      email: 'E-mail',
      mobile: 'Mobile',
      searchForPatient: 'Search for a {personType}',
      defaultSubject:
        '{firstName} {lastName} from {group} would like to start a secure conversation with you. Please click the link to accept.',
      markConversation: 'Mark this conversation as {label}?',
      assignConversation: 'Assign this conversation to {label}?',
      attachToMessage: 'Attach to message',
      saveAsTemplate: 'Save as Template',
      sendMessage: 'Send message',
      messagePreview: 'Message preview',
      selectCategory: 'Please select a category',
      invitationSent: 'Invitation sent to {message}',
      openConversationHeader: '{agentName} is conversing with the {personType}',
      waitingRoomHeader: '{botName} (Bot) is conversing with the {personType}',
      waitingRoomFinishedHeader:
        '{botName} (Bot) is finished conversing with the {personType}',
      takeover: 'Takeover',
      closedConversation:
        "This conversation is closed. You can reopen it if you'd like to continue the discussion.",
      blockTypingAlert:
        "This conversation is assigned to a bot. Takeover if you'd like to start the conversation.",
      blockTypingAlertAssign:
        "This conversation is assigned to {assignee}. You cannot reply unless it's assigned to you.",
      openedSubtab: 'Open conversations',
      widget: 'Widget',
      allWidgets: 'All Widgets',
      routine: 'Routine Follow-up',
      startVideoChatWarning: 'Would you like to start a Video Chat?',
      joinVideoChatWarning: 'Would you like to join a Video Chat?',
      startVoiceCallWarning: 'Would you like to start a Voice Call?',
      startScreenSharingWarning: 'Would you like to start Screen Sharing?',
      joinScreenSharingWarning: 'Would you like to Share your Screen?',
      startCall: 'Start Call',
      startVoiceCall: 'Start a Voice Call',
      resendInvite: 'Resend Invite',
      resendInvitation: 'Resend invitation',
      editPatient: 'Edit patient',
      messages: 'Messages',
      smsTimeline: 'SMS Timeline',
      smsStatus: 'SMS status',
      emailTimeline: 'Email timeline',
      emailStatus: 'Email status',
      timeline: 'Timeline',
      soloWarning: "Looks like you're the only one here!",
      addParticipant: 'Add participant',
      controls: 'Controls',
      welcomeMessage: 'Secure Welcome Message',
      virtualBg: 'Virtual Backgrounds',
      shareScreen: 'Share the screen',
      stopSharing: 'Stop Sharing',
      guest: 'A Guest',
      interpreter: 'An interpreter',
      videoChatControls: 'Video Chat Controls',
      audioChatControls: 'Audio Chat Controls',
      addVideoChatParticipants: 'Add video chat participants',
      addVideoChatInterpreter: 'Adding interpreter',
      language: 'Language',
      service: 'Service',
      interpreterDetails:
        '{name} will receive the following details at {email}:',
      facilityName: 'Facility Name',
      providerFirstName: 'Provider First Name',
      providerLastName: 'Provider Last Name',
      languageRequested: 'Language Requested',
      conversationLink: 'Conversation Link',
      patientEmailSubjectAlert:
        '{patient} will receive the above email followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      patientSubjectAlert:
        '{patient} will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      patientWelcomeAlert:
        '{patient} will receive the above welcome message when they launch the conversation, in the event that a Chatbot is not assigned to the Chat Widget.',
      welcomeMessageRevertWarn:
        'Would you like to revert the changes and use the default Welcome message?',
      selectInvintationSourse: 'Please select the invitation source',
      fillInRequiredFields: 'Please fill in all required fields',
      telephony: {
        callerIdHint:
          'The phone number that the patient will receive the call from',
        confirm:
          'Would you like to place a call from {callerId} to {phoneNumber}?',
        patientPhoneNumber: 'Patient Phone Number',
        providerCallerId: 'Provider Caller Id',
      },
      closedPatientConversation: 'This conversation is closed.',
      noReplyPatientConversation: "You can't reply to this conversation",

      uploadToEmr: {
        titles: {
          uploadToEmr: 'Upload to EMR',
          uploadConversationToEmr: 'Upload Conversation to EMR',
        },
      },
      statuses: {
        close: 'Close',
        closed: 'Closed',
        spam: 'Spam',
        open: 'Open',
        noReply: 'No reply',
        assignedToBot: 'Assigned to bot',
        escalated: 'Escalated',
        archived: 'Archived',
        unassigned: 'Unassigned',
        canceled: 'Canceled',
        duplicate: 'Duplicate',
        invited: 'Invited',
      },
      plusChat: {
        validation: {
          dobFormat: 'Required Format: MM-DD-YYYY',
          phoneFormat: 'Please enter correct phone format',
        },
        buttons: {
          add: 'add',
          cancelSearch: 'Cancel Search',
          confirm: 'Confirm',
          document: 'Document',
          change: 'Change',
          createNew: 'Create New',
          insurance: 'Insurance',
          reset: 'Reset',
          select: 'Select',
          setPatient: 'Set Patient',
          upload: 'Upload',
          search: 'Search',
          moreFilters: 'More Filters',
          removeFilter: 'Remove Filter',
          inviteBy: {
            sms: 'SMS',
            email: 'Email',
            unknown: 'Unknown',
          },
          addPhoneNumber: 'Add Phone number',
        },
        errors: {
          noSearchLines: '*Please enter at least one search criteria',
          masterPayerList: 'Error Loading Master Payer List',
          patientPayerList: 'Error Loading Patient Payer List',
          createInsuranceError: 'Error Creating Insurance',
          selectGroup: 'At least one group should be selected',
        },
        labels: {
          chatWidgetSelect: 'Chat widgets',
          chatWidgetBots: 'Chat bots',
          dob: 'DoB',
          personNumberAbbreviation: 'PN',
          emailInput: 'Email Address',
          emailSelect: 'Email list',
          identifier: 'Identification Number',
          mrn: 'MRN',
          email: 'Email',
          mobile: 'Mobile Number',
          inviteBy: 'Invite By',
          name: 'Name',
          patient: 'Patient',
          patientInsuranceSelect: "Pick patient's insurance",
          phoneNumber: 'Phone Number',
          searchResults: '{0} search results',
          uploadAs: 'Upload as',
          inviteSent: 'Invitation Sent Successfully',
          locateInvitations:
            'You can find the Invites Sent at the bottom left of your screen.',
          dontShowAgain: "Don't show this again",
          or: 'or',
        },
        messages: {
          destinationPatientChanged: 'Successfully Changed Destination Patient',
          emrUploadEnqueued: 'File Upload to EMR Enqued',
          uploadError: 'Upload Error',
        },
        placeholders: {
          chatWidgetSelect: 'Select a chat widget',
          emailInput: 'Enter a valid email',
          emailSelect: 'Select an email address',
          emrSelect: 'Choose Database',
          phoneNumberInput: 'Enter a valid SMS capable number',
          phoneNumberSelect: 'Select a phone number',
          botDesigner: 'Select bot',
          noBotSelected: 'No bot',
        },
        titles: {
          conversationStarted: 'Conversation Started',
          invitePatient: 'Invite Patient',
          startConversationWith: 'Start Conversation with',
        },
        tooltips: {
          privatePatients: 'Search only your {personType}s',
        },
        box: '{{ patient.fullName }} will receive the above message(s) followed by a link. When they click the link they will be redirected to a secure conversation with you.',
      },
    },

    quickSign: {
      date: 'Date',
      name: 'Name',
      initialsHere: 'Initials Here',
      confirmSubmit: 'Ready to submit?',
      completedSuccess: 'Quick Sign document Completed successfully',
    },

    invitationMessages: {
      statuses: {
        forbidden: 'Forbidden',
        delivered: 'Delivered',
        sent: 'Sent',
        opened: 'Opened',
        service_request_failed: 'Service request failed',
      },
    },

    messages: {
      recalled: 'Message has been recalled',
      recalledConfirm: 'Are you sure you want to recall this message?',
      recalledBySender: 'Message recalled by the sender',
      success: {
        conversationCreate: 'A conversation has been created!',
        inviteResend: 'An invite has been successfully resent!',
        patientUpdate: 'Patient has been updated!',
        interpretorInvited: 'An interpretor has been invited successfully!',
        conversationUpdate: 'A conversation status has been updated!',
      },

      warning: {
        deleteInvitation: 'Would you like to cancel the Invitation?',
      },

      error: {
        takeover: 'Failed to perform a takeover. Please try again later.',
        inviteResend: 'Failed to resend an invite. Please try again later.',
        translationServices:
          'Failed to load translation services list. Pleas, try again later',
        inviteInterpretor:
          'Failed to invite interpretor. Please, try again later',
        conversationUpdate:
          'Failed to change the status of the conversation. Please try again later',
      },

      common: {
        endOfSearch: 'End of search results',
        noOpenedConversationsFound: 'No conversations found',
      },
    },

    audioTest: {
      userBrowser: 'Browser Version on User OS User Device',
      skip: 'Skip',
      testAgain: 'Test again',
      viewTroubleShoot: 'View Troubleshooting Instructions',
      instructions: 'Troubleshooting Instructions',
      start: 'TEST YOUR EQUIPMENT',
      title: 'Test Audio / Camera',
      unsupported: 'Unsupported',
      testCamera: 'Test camera',
      testMicrophone: 'Test microphone',
      doYouSeeMic: 'Do you see a blue progressbar while speaking ?',
      testAudio: 'Test Speaker',
      didYouHear: 'Did you hear the sound ?',
      playAgain: 'Play again',
      loading: 'Detecting devices...',
      canYouSee: 'Can you see yourself ?',
      safariMessage:
        'This version of Safari browser has issues with audio. Apple has released an update to address audio issues. Please update your iOS to the latest version.',
      instruction:
        'We will be testing your camera, microphone, and speaker to ensure you have the best Virtual Visit experience.',
    },

    virtualBg: {
      title: 'Choose background',
      preview: 'Preview',
      backgrounds: 'Backgrounds',

      names: {
        none: 'None',
        blur: 'Blur',
        add: 'Add image',
      },

      actions: {
        apply: 'Apply',
      },
    },

    video: {
      dataMessages: {
        unintentionalMute: '{name} Muted',
      },
      troubleshooting: {
        unableToHear: 'I am unable to hear you.',
        unableToSee: 'I am unable to see you.',
        unmute: 'Please unmute your audio.',

        remoteParticipantTroubleshooting:
          'Please standby. {name} has received the request and is undergoing device troubleshooting.',

        messages: {
          unableToHear: 'I am unable to hear you.',
          unableToSee: 'I am unable to see you.',
          unmute: 'Please unmute your audio.',
          wentBackground:
            'Put their video call into the background. This may effect their audio and video feeds',
          screenShareWentBackground:
            'Put their Screen Sharing into the background. This may effect their audio and and screen sharing feeds',
          wentFrontground: 'Returned to the chat',
          participantHasIssues:
            'The other participant is experiencing some video issues or lost connection, please wait!',
          participantHasConnectionIssues:
            'The other participant is experiencing some connection issues, please wait!',
          permissionVideoError:
            'We are having trouble accessing your Microphone or Camera. Please allow permission to access your Microphone and Camera.',
          permissionAudioError:
            'We are having trouble accessing your Microphone. Please allow permission to access your Microphone.',
        },
      },

      feedback: {
        title: 'How was the video call experience?',
        titleScreenSharing: 'How was the Screen Sharing experience?',
        commentPlaceholder: 'Please share your feedback',

        messages: {
          success: 'Feedback was sent successfully',
          fail: 'Failed to send a feedback. Please try again later',
        },
      },
      muteConversation: 'Mute conversation chimes',
      unmuteConversation: 'Unmute conversation chimes',
      screenSharingError:
        'Failed to share the screen. The issue is probably related to your system permissions. Please adjust your privacy/permissions settings on your device and try again.',
      screenSharingNotAllowed:
        'Screen sharing is only available from a desktop browser. Mobile and tablet devices are not supported.',
      screenSharingNotSuported:
        'This screen sharing session can only be joined from a desktop browser. Mobile and tablet devices are not supported.',
    },

    hints: {
      bot: 'You cannot assign a bot while another bot is conversing.',
    },
    buttons: {
      openToSign: 'Open to sign',
      submitted: 'Submitted',
      markAsCompleted: 'Mark as Completed',
      recall: 'Recall',
    },
    validation: {
      fieldsToFill: '{field} of {allFields} fields are filled',
      fieldsOutOfFilled: '{field} out of {allFields} filled',
      fillRequiredFields: 'Please fill all required fields',
    },

    aiAgent: {
      followUp: 'Follow Up Questions',
      answer: 'Answer',
      recommendationLinks: 'Links from web',
      youTubeLinks: 'Video Recommendation',
      refresh: 'Refresh',
      copy: 'Copy to clipboard',
      copied: 'Successfully copied',
    },
  },

  quickForms: {
    labels: {
      zip: 'Zip Code',
      city: 'City',
      state: 'State',
      diastolic: 'Diastolic',
      systolic: 'Systolic',
      time: 'Time',
      unit: 'Units',
      timesPer: 'Times per',
      formPreview: 'Form preview',
      addAnother: 'Add another',
      compressing: 'Compressing...',
    },
  },

  common: {
    locationDenied:
      'Position error, because the user denied permission. Please enable location permission on your device',
    locationError: 'Location was not found. Try to change provided ZIP code',
    noDescription: 'No description',
    loading: 'Loading...',
    noContent: 'No content',
    empty: 'Empty',
    na: 'N/A',
    renewError: 'Failed to renew session. Please try logging in again.',
    httpError: 'Unknown error. Please, try again later.',
    translateError: 'Translation error. Please, try again later.',
    authError: 'Authentification failed. Contact the administator for details',
    warning: 'Warning',
    successExport:
      'Your CSV file is being processed. Once the job is completed you will be notified.',
    failedExport: 'Failed to export as CSV',
    successExportLogout:
      'Logout CSV Export Job is submitted. You will be notified once the CSV file is ready...',
    successExportJob:
      'CSV Export Job is submitted. You will be notified once the CSV file is ready...',
    errorDownloadQuickSign: 'Unable to download Quick Sign Document data',
    errorDownloadQuickForm: 'Unable to download Form Submissions Document data',
    successPdfGenerating: 'PDF generated and downloaded',
    primaryShiftMembers: 'Primary Shift Members',
    backupShiftMembers: 'Backup Shift Members',
    to: 'to',
    internalServerError: 'Internal Server Error',
    serverError: 'Server error - Please try again',
    networkError:
      'Network error - Please check your internet connection and try again.',
    forbiddenError: `Sorry, you don't have permission to access this action.`,
    errorNotFound: 'The requested resource could not be found on the server.',
    mediaError:
      'The server does not support the media type provided in the request.',
    tooManyRequestsError:
      'The user has sent too many requests in a given amount of time.',
    badGatewayError: 'Bad Gateway',
    unavailableServiceError:
      'The server is currently unavailable due to maintenance or overload',
    timeoutGatewayError:
      'The server did not receive a timely response from the upstream server while attempting to load the requested resource',
    defaultError: 'Oops! Something went wrong.',
    badRequestError: 'Client error, such as malformed request.',
  },

  alerts: {
    chat: {
      resendInvitationWarn:
        '{patient} will receive the above text message followed by a link. ' +
        'When they click the link they will be redirected to a secure conversation with you.',
      resendInvitationNoChatBotWarn:
        '{patient} will receive the above welcome message when ' +
        'they launch the conversation in the event that a Chatbot is not ' +
        'assigned to the Chat Widget.',
      noPhiEmail: 'No PHI here - this will be sent over Email',
      noPhiSms: 'No PHI here - this will be sent over SMS',
      smsInformation:
        'New patient will receive the above text message followed by a link. When they click the link they will be redirected to a secure conversation with you.',
    },

    chatWidgets: {
      customization: {
        updatedSuccess: '{type} saved',
        updateFail: 'Failed to update {type}. Please try again later.',
        deleteMsqSuccess: '{type} Message deleted successfully',
        deleteMsqFail: 'Failed to delete {type}. Please try again later.',
      },
    },

    errors: {
      unexpected: 'Unexpected error happened. Please try again later',
      pdfLoadError: 'Failed to load PDF',
      collectedInfo: 'Cant load collected info',
    },
  },

  chatWidgetMessageType: {
    CHAT_WIDGET_MESSAGE_TYPE_UNDEFINED: 'Undefined',
    WELCOME: 'Welcome',
    ANONYMOUS: 'Anonymous',
    KNOWN: 'Known',
    TEASER: 'Teaser',
    TAC: 'TAC',
    START: 'Start',
    COMPLIANCE: 'Compliance',
    ABOUT: 'About',
    CUSTOM_WELCOME: 'Custom Welcome',
    AUTH_FAILED: 'Auth Failed',
  },

  shortWeekDays: {
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
  },

  availability: {
    setCustomAvailability: 'Set custom availability for this widget',
    setWeeklyHours: 'Set your weekly hours',
    addDateOverrides: 'Add date overrides',
    addDatesDesc:
      'Add dates when your availability changes from your weekly hours',
    selectDate: 'Select the date(s) you want to assign specific hours',
    weekly: {
      days: 'Days',
      startTime: 'Start Time',
      endTime: 'End Time',
      actions: 'Actions',
    },
    unavailable: 'Unavailable',
    date: 'Date',
    title: 'Availability',
  },

  notifications: {
    newConversation: 'New conversation was assigned to you',
    file: 'File',
    newMessage: 'You received a new message',
    conversationReassigned: 'Conversation reassigned',
    conversationAssigned: 'Conversation assigned to {name}',
    copiedToClipboard: '{item} copied',
    resetPasswordError: 'Failed to reset the password for user',
    changeEmailSuccess:
      '{fullName} will receive a notification about the change of email.',
    changeEmailNotUnique: 'Email is used by another user',

    passwordFor:
      'Password for <b>{fullName}</b> is changed to <b>{generatedPassword}</b>. ',
    mobileSent: 'A mobile message is sent to <b>{mobileNumber}</b>. ',
    emailSent:
      'An email is sent to <b>{email}</b>. The email could be delayed or dropped by spam filters. ',
    conveyDirectly: 'Please convey the password to the user directly. ',
    linkGenerated: 'Reset password link is generated for <b>{fullName}</b>. ',
    mustClick:
      'User must click the link and select password before logging into the client. ',
  },

  key: 'Key',
  shareLink: 'Share link',
  saveAndReturn: 'Save and return to Group Management.',

  pagination: {
    fromTo: 'Showing {from} to {to} of {entries} Entries',
    show: 'Show',
    perPage: 'Per Page',
    page: 'Page',
  },

  activityRadios: {
    lastHours: 'Last 24 hours',
    days: '7 days',
    mDays: '30 days',
    months: '3 months',
    all: 'All',
    currentMonth: 'Current month',
  },

  rowsPerPage: 'Rows per page',

  locales: {
    spanish: 'Español',
    french: 'Français',
  },

  help: {
    title: 'If you have an emergency, call 911 at once.',
    newConversation: 'New conversation',
    speakToHuman: 'Speak to human',
  },

  appToolbar: {
    impersonationActive: 'Impersonation active',
    exit: 'Exit',
    logout: 'Logout',
    addNewGroup: '+ New Group',

    addNewGroupDialog: {
      title: 'Create Group',
      alert:
        'I would like to create a group that needs HIPAA Secure Texting. I will be the administrator of the group.',
      success: 'Group successfully created',
      error: 'Error creating group',
      validation: '{name} cannot be blank.',

      labels: {
        groupName: 'Group Name',
        groupPhone: 'Group Phone',
        groupWebsite: 'Group Website',
        addressLine1: 'Address Line1',
        addressLine2: 'Address Line2',
        city: 'City',
        zip: 'Zip',
      },
    },

    appNotifications: {
      notifications: 'Notifications',
      noNotifications: 'No notifications',
      fetchError: 'Error fetching notifications',
    },

    changeCurrenGroup: {
      error: 'Error changing group',
    },
  },

  chooseOptions: 'Choose Option',
  timezone: 'Timezone',
  savedSuccessfully: 'Success! Saved successfully!',
  exclusions: 'Exclusions:',
  successCopy:
    '{target} has been copied over to {group} {isGroup} successfully',
  fillOptionFields: 'Options list cant be empty, please fill or add option',
  videoChat: {
    userIsSharingScreen: '{name} is sharing the screen',
    youAreSharingScreen: 'You are sharing the screen',
    finishVideoChatWarning: 'Do you want to end the Video Chat?',
    finishVoiceChatWarning: 'Do you want to end the Audio Chat?',
    finishScreenSharingWarning: 'Do you want to end the Scren Sharing?',
    errors: {
      mediaPermissionDenied: {
        title: 'We cannot connect you',
        cameraDenied:
          'Looks like your audio or camera permissions have been denied',
        audioDenied: 'Looks like your audio permissions have been denied',
        troubleshoot: 'Troubleshoot',
        clickBelow:
          'Please click "Troubleshoot" button below for a short clip on how to fix your permissions',
      },
      mediaDeviceInUse: {
        title: 'Your camera or microphone is already being used',
        message:
          'Another app may be using your camera or microphone. ' +
          'If you are on any sort of call (phone call, Skype, Zoom, GoToMeeting, WebEx, etc) ' +
          'or recording using your camera or microphone, ' +
          'please stop the call or recording, refresh the page, and try again.',
      },
      mediaDeviceMissing: {
        title: 'You need a microphone and webcam',
        message:
          'You cannot have a video chat without having a microphone and a webcam. ' +
          'Both are required. Please connect them and install any software drivers that may be missing, ' +
          'refresh the page, and try again',
      },
      safariOutdated: {
        title: 'Please upgrade to at least iOS 12',
        message:
          'You are using an old version of iOS that is not supported. Please upgrade or use a different device.',
      },
      deviceUnsupported: {
        title: 'This device does not allow Video Chat',
        message: 'Please try carrying out the video chat on a different device',
      },
      browserOutdated: {
        title: 'Please upgrade your browser',
        message:
          'The internet browser you are using is outdated. Please upgrade it and retry',
      },
      browserUnsupported: {
        title: 'This browser does not allow Video Chat',
        message:
          'You may need to upgrade your browser, or try on a different browser',
      },
    },
    refreshPage: 'Refresh page',
    twilioError: {
      genericTitle: 'Twilio service interrupted',
      genericMessage:
        'Service should be up and running shortly, please check back later',
      '53000': {
        title: 'Internal Server Error',
      },
      '20500': {
        title: 'Signaling connection error',
      },
    },
  },
  selfScheduler: {
    bookingConfirmed: 'Your booking is confirmed',
  },
  messageActivity: {
    timeInfoBanner: {
      cdt: '* Times are in Central Daylight Time (CDT)',
      ct: '* Times are in Central Time (CT)',
    },
    qliqID: 'QliqID',

    table: {
      mlid: 'MLID',
      mid: 'MID',
      uuid: 'UUID',
      sender: 'Sender',
      senderQliqId: 'Sender Qliq ID',
      receiver: 'Receiver',
      receiverQliqId: 'Receiver Qliq ID',
      createdTime: 'Created Time',
      deliveredTime: 'Delivered Time',
      sentTime: 'Sent Time',
      readTime: 'Read Time',
      deletedTime: 'Deleted Time',
      ackedTime: 'Acked Time',
      incoming: 'INCOMING',
      type: 'TYPE',
      id: 'ID',
      iid: 'IID',
      deviceNumber: 'Device/number',
      status: 'Status',
    },
  },
  secureMessages: {
    table: {
      sentTo: 'Sent to',
      deliveredTo: 'Delivered to',
      readBy: 'Read by',
      ackedBy: 'Acked by',
    },
  },
  virtualVisitsActivity: {
    title: 'Virtual Visit Activity',

    statuses: {
      0: 'All',
      1: 'Failed',
      2: 'Declined',
      3: 'No Answer',
      4: 'Left',
      5: 'Created',
      6: 'Joined',
    },
    labels: {
      agents: 'Agents',
      widgets: 'Chat widgets',
      filterStatus: 'Filter by Status',
      totalNumberVisits: 'Total Number of Visits',
      totalNumberScreenSharing: 'Total Number of Screen Sharing Sessions',
      totalNumberAudioCalls: 'Total Number of Audio Calls',
      averageDuration: 'Average Duration',
      visitLessMinute: 'Visits less than a minute',
      screenSharingLessMinute: 'Screen Sharing less than a minute',
      sessionsLessMinute: 'Sessions less than a minute',
      visitLongerMinutes: 'Visits longer than 5 minutes',
      sessionsLongerMinutes: 'Sessions longer than 5 minutes',
    },
    tables: {
      failureReason: 'Failure reason',
      name: 'Name',
      widget: 'Widget',
      mobileNumber: 'Mobile Number',
      started: 'Started',
      joined: 'Joined',
      left: 'Left',
      duration: 'Duration',
      currentStatus: 'Current Status',
      rating: 'Rating',
    },
    rating: {
      messageBox: {
        title: 'Feedback Comment',
        confirmButtonText: 'Close',
      },
    },
  },
  troubleShooting: {
    finishVideoChatWarning: 'Do you want to end the Video Chat?',
  },
  emrConnections: {
    0: 'NextGen',
    1: 'QliqSOFT',
    2: 'Athena Health',
    3: 'Cerner',
    4: 'CPSI Thrive',
    5: 'EClinicalWorks',
    6: 'Epic',
  },
  kiosk: 'Kiosk',
  clearAll: 'Clear All',

  throttlingLimits: {
    title: 'Throttling Limits',
    concurrencyLimit: 'Concurrency Limit',
    thresholdLimit: 'Threshold Limit',
    thresholdPeriod: 'Threshold Period (seconds)',
    error: 'Cant update throttling limits',
    success: 'Throttling limits updated successfully',
    validationNumber: 'Please enter a number',
  },

  announcementPage: {
    title: 'Announcement',
    from: 'From',
    newAnnouncement: 'New Announcement',
    fetchError: 'Can not fetch announcements, try again later',
    fetchExportError: 'Can not export announcements, try again later',
    fetchExportSuccess: 'Announcements exported successfully',
    table: {
      subject: 'Subject',
      message: 'Message',
      created: 'Created',
      delivered: 'Delivered',
      deliveredTo: 'Delivered to',
      sent: 'Sent',
      sentTo: 'Sent to',
      read: 'Read',
      readBy: 'Read by',
    },
    creating: {
      unsavedTitle: 'Unsaved Changes Alert',
      unsavedChanges:
        'You have unsaved changes to your announcement. Closing this window will result in the loss of your data. Do you still want to close the drawer?',
      fetchError: 'Can not create announcement, try again later',
      success: 'Announcement created successfully',
      to: 'To',
      title: 'Send Announcement to Group/Subgroup',
      titleSuper: 'Send Announcement to Group',
      description:
        "You can send message either to {name} or subgroup's of {name}",
      receiver: {
        SUBGROUPS: 'Subgroups',
        GROUP: 'Group',
      },
      subject: 'Enter subject',
      schedule: 'Schedule',
      message: 'Enter your message',
      selectPlatforms: 'Select the platforms',
      selectUsers: 'Select the users',
      dateNow: 'Now',
      dateLater: 'Later',
      announcementMemberType: {
        MEMBER: 'Members',
        NON_MEMBER: 'Non Members',
        ADMIN: 'Admins',
      },
      announcementPlatform: {
        IOS: 'iOS',
        ANDROID: 'Android',
        WINDOWS: 'Windows',
        MAC: 'Mac',
        BROWSER: 'Web Browser',
      },
      pickDay: 'Pick a day',
    },

    breadcrumbs: {},
    notifications: {},
  },

  noData: 'No data',

  enums: {
    APPOINTMENT_BOOKED: 'Booked',
    APPOINTMENT_COMPLETED: 'Completed',
    APPOINTMENT_CANCELED: 'Canceled',
    APPOINTMENT_NO_SHOW: 'No show',
    APPOINTMENT_CONFIRMED: 'Confirmed',
    APPOINTMENT_DELETED: 'Deleted',
    APPOINTMENT_NO_SHOW_LIKELY: 'No show likely',

    BILLING_CREATED: 'Created',
    BILLING_OPENED: 'Opened',
    BILLING_SENT: 'Sent',
    BILLING_OUTSTANDING: 'Outstanding',
    BILLING_ABANDONED: 'Abandoned',
    BILLING_ERRORED: 'Errored',
    BILLING_PAID: 'Paid',

    MEDICATION_REFILL_CREATED: 'Created',
    MEDICATION_REFILL_SUBMITTED: 'Submitted',
    MEDICATION_REFILL_UPLOADED: 'Uploaded',

    ALL_DEVICES: 'All Versions',
    BEHIND_ONE: 'One Version Behind',
    BEHIND_TWO: 'Two Versions Behind',
    BEHIND_THREE_PLUS: 'Three or more Versions Behind',

    UNKNOWN_OS: 'All Operating Systems',
    WINDOWS: 'Windows',
    MAC_OS: 'MacOS',
    IOS: 'iOS',
    ANDROID: 'Android',
    LINUX: 'Linux',
    WEBSERVICE: 'Web Service',
  },
  speech: {
    error: 'Speech recognition error: {error}',
  },
  customAtributes: {
    personType: {
      PERSON_PATIENT: 'Patient',
      PERSON_PROVIDER: 'Provider',
      PERSON_CLINICIAN: 'Clinician',
      PERSON_CLIENT: 'Client',
      PERSON_TECHNICIAN: 'Technician',
      PERSON_PHYSICIAN: 'Physician',
      PERSON_NURSE: 'Nurse',
      PERSON_CAREGIVER: 'Caregiver',
      PERSON_THERAPIST: 'Therapist',
      PERSON_MEMBER: 'Person member',
      PERSON_EMPLOYEE: 'Person employee',
      ORDER: 'Order',
    },
  },
  typingStatuses: {
    UNKNOWN: '',
    THINKING: 'Thinking',
    PREPARING: 'Preparing Response',
    RESPONDING: 'Responding',
  },
}
